import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import MetaTags from '../components/MetaTags';
import api from '../api/axios';
import './new-pages.css';

const PLACEHOLDER_FAQS = [
  { id: 1, category: 'Membership', question: 'How do I become a member of MNCW?', answer: 'Visit our Membership page and complete the online registration form. Fill in your family details and pay the $50 fee online via card. Your 2-year membership will be activated after payment confirmation.' },
  { id: 2, category: 'Membership', question: 'How much does membership cost?', answer: 'Family membership is $50 for a 2-year period, covering your entire family (couple and children).' },
  { id: 3, category: 'Membership', question: 'How do I check my membership status?', answer: 'Go to the Membership Lookup page and enter your first name, last name, and date of birth to find your membership number and expiry date.' },
  { id: 4, category: 'Events', question: 'Do I need to register for MNCW events?', answer: 'Yes, most MNCW events require registration as places are limited. Visit our Events page to see upcoming events.' },
  { id: 5, category: 'Events', question: 'Are events free for members?', answer: 'Some events are free for financial members, while others have a subsidised ticket price. Non-members pay the full ticket price.' },
  { id: 6, category: 'Community', question: 'How can I get involved with MNCW?', answer: 'Join as a member, attend our events, follow us on social media, and volunteer at community events. You can also stand for election to the committee at the AGM.' },
  { id: 7, category: 'General', question: 'Where is MNCW based?', answer: 'MNCW serves Nepalese communities across Melbourne\'s western suburbs including Melton, Caroline Springs, and surrounding areas.' },
];

function FaqItem({ faq, defaultOpen }) {
  const [open, setOpen] = useState(defaultOpen || false);
  return (
    <div className="faq-item">
      <button className={`faq-question${open ? ' open' : ''}`} onClick={() => setOpen(o => !o)}>
        {faq.question}
        <i className={`fas fa-chevron-${open ? 'up' : 'down'}`} style={{ fontSize: '0.8rem', flexShrink: 0 }}></i>
      </button>
      <div className={`faq-answer${open ? ' open' : ''}`}>{faq.answer}</div>
    </div>
  );
}

export default function FAQPage() {
  const [site, setSite] = useState(null);
  const [pageLoading, setPageLoading] = useState(true);
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    fetch('/content.json')
      .then(r => r.json())
      .then(d => { setSite(d.site); setPageLoading(false); })
      .catch(() => setPageLoading(false));

    api.get('/faq').then(r => setFaqs(r.data || [])).catch(() => {});
  }, []);

  const display = faqs.length > 0 ? faqs : PLACEHOLDER_FAQS;
  const categories = [...new Set(display.map(f => f.category))];

  if (pageLoading) return <div className="page-loading"><div className="spinner-ring"></div></div>;
  if (!site) return null;

  return (
    <div className="App">
      <MetaTags
        title="FAQ | Melbourne Nepalese Community West"
        description="Frequently asked questions about MNCW membership, events, and community programs."
        url="https://mncw.org.au/faq"
        image="https://mncw.org.au/assets/img/logo.jpg"
        type="website"
      />
      <Header data={site} />

      <div className="faq-page-container">
        <div className="container">
          <div style={{ maxWidth: 760, margin: '0 auto' }}>
            <div className="page-header">
              <span className="page-subtitle">Help Centre</span>
              <h1>Frequently Asked Questions</h1>
              <p className="page-intro">Everything you need to know about MNCW membership and community programs.</p>
            </div>

            {categories.map(cat => {
              const items = display.filter(f => f.category === cat);
              return (
                <div key={cat} className="faq-category">
                  <h3><i className="fas fa-tag"></i> {cat}</h3>
                  {items.map((f, i) => (
                    <FaqItem key={f.id} faq={f} defaultOpen={i === 0 && cat === categories[0]} />
                  ))}
                </div>
              );
            })}

            <div style={{ textAlign: 'center', marginTop: 48, paddingTop: 40, borderTop: '2px solid var(--light-bg)' }}>
              <p style={{ color: 'var(--text-light)', marginBottom: 20 }}>Still have questions?</p>
              <Link to="/feedback" className="btn-mncw">
                <i className="fas fa-envelope"></i> Contact Us
              </Link>
            </div>
          </div>
        </div>
      </div>

      <Footer data={site} />
    </div>
  );
}
